import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PageTemplate, PageTitle, Box, Container } from '../PageTemplate';
import { ProfileForm, LogoForm } from './';
import { UserActions } from '../../actions';
import './profilePage.scss';

class ProfilePage extends Component {

    componentDidMount() {
        this.props.dispatch(UserActions.getData());
    }

    render() {
        return (
            <PageTemplate id="profilePage">
                <PageTitle icon="faUser">
                    הפרופיל שלי
                </PageTitle>
                <Container>
                    <Box col="2">
                        <ProfileForm />
                    </Box>
                    <Box col="2">
                        <LogoForm />
                    </Box>
                </Container>
            </PageTemplate>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        user: state.userReducer
    }
}

const ProfilePageWithRedux = connect(mapStateToProps)(ProfilePage);

export {ProfilePageWithRedux as ProfilePage};


// WEBPACK FOOTER //
// ./src/components/ProfilePage/ProfilePage.jsx